var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"searchFilter"},[_c('iconic',{staticClass:"searchFilter__icon",attrs:{"name":_vm.icon}}),_c('input',{staticClass:"searchFilter__input",attrs:{"type":"text","placeholder":_vm.placeholder},on:{"input":(event) => _vm.$emit('onChange', event)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }